import PropTypes from 'prop-types';
import './Loading.css';

/**
 * Reusable Loading spinner component
 *
 * @param {Object} props
 * @param {string} props.size - Spinner size: 'small', 'medium', 'large'
 * @param {string} props.text - Optional loading text to display
 * @param {boolean} props.fullScreen - Whether to display as full-screen overlay
 * @param {string} props.color - Spinner color: 'primary', 'secondary', 'white'
 */
const Loading = ({
  size = 'medium',
  text = '',
  fullScreen = false,
  color = 'primary',
  className = '',
}) => {
  return (
    <div className={`loading ${fullScreen ? 'loading--fullscreen' : ''} ${className}`}>
      <div className={`spinner spinner--${size} spinner--${color}`} role="status">
        <span className="spinner-sr-only">Loading...</span>
      </div>
      {text && <p className="loading-text">{text}</p>}
    </div>
  );
};

Loading.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  text: PropTypes.string,
  fullScreen: PropTypes.bool,
  color: PropTypes.oneOf(['primary', 'secondary', 'white']),
  className: PropTypes.string,
};

export default Loading;
